module.exports = __webpack_public_path__ + "static/media/5.de32f706.png";